import { useCallback, useMemo } from 'react';
import useSpeechRecognition from '../../hooks/useSpeechRecognition';
import type { ThemeHistory } from '../../hooks/useThemeHistory';
import type { VoiceState } from './types';

/** Hold-to-talk dictation appended to the idea box (typed text: edits the head in place, after an idea: a new entry). */
export default function useComposerVoice(themeHistory: ThemeHistory, language: string): VoiceState {
  const { setUserValue } = themeHistory;
  const onResult = useCallback((transcript: string) => {
    setUserValue((prev) => (prev + ' ' + transcript).trim());
  }, [setUserValue]);
  const { isListening, isSupported, start, stop } = useSpeechRecognition(onResult, language);
  return useMemo(() => ({ supported: isSupported, listening: isListening, start, stop }), [isSupported, isListening, start, stop]);
}
